<template>
    <div class="list-media" v-if="!!params.minivedio && params.minivedio.length>0">
        <div class="media-title" v-if="params.title_box">
            <div class="title-txt">
                {{params.title}}
            </div>
            <div class="title-more" @click="onClick(params.link)" v-if="params.more_box">
                {{params.more}}
            </div>
        </div>
        <div class="micro-content">
            <swiper class="swiper my-swipe" :options="swiperOption">
              <swiper-slide class="my-swipe-item" v-for="(item,index) in params.minivedio" :key="index"  >
                <div class="micro-item">
                  <van-image
                      class="swiper-img"
                      fit="cover"
                      @click="onClick(item.link)"
                      :src="item.img"
                  />
                </div>
              </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
    import { Image as VanImage,Swipe, SwipeItem } from 'vant';
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/swiper-bundle.css'

    export default {
        name: "list_media",
        props:{
            params: Object
        },
        components:{
            [VanImage.name]:VanImage,
            [Swipe.name]:Swipe,
            [SwipeItem.name]:SwipeItem,
            Swiper,SwiperSlide
        },
        data(){
            return {
                micro_width:150,
                swiperOption: {
                  slidesPerView: 'auto',
                  spaceBetween: 5,
                  freeMode: true,
              }
            }
        },
        created() {
          console.log("createdcreatedcreatedcreated")
        },
        mounted() {
            // 兼容处理，由于插件必须指定像素
            var initFontSize = 37.5
            var iPhone6Width = 375
            var clientWidth = window.document.documentElement.clientWidth || iPhone6Width
            var newFontSize = initFontSize * (clientWidth / iPhone6Width)
            if(clientWidth!=375){
              this.micro_width = newFontSize*150/initFontSize
            }

        },
        methods: {
            onClick(link) {
                // this.util.carouselUrl(link);
                if(!!link){
                    this.$router.push(link);
                }
            },
        },
    }
</script>

<style scoped>
    
    .list-media .content-lecturer{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        color: #999999;
        margin: 4px 0;
        font-size: 12px;
        height: 17px;
    }
    .content-info{
        display: flex;
        line-height: 16px;
    }
    .content-info-play-money{
        font-size: 12px;
        color: #FF624F;
    }
    .content{
        box-shadow: 1px 7px 10px #eee;
        min-height: 35px;
        padding: 8px;
        border-radius: 0 0 5px 5px;
    }
    .list-media{
        width: 100%;
        /*margin-top: 10px;*/
        margin: 10px 0;
    }
    .media-title{
        background-color: #fff;
    }
    .media-title .title-txt,.media-title .title-more{
        display: inline-block;
        vertical-align: middle;
    }
    .media-title .title-txt{
        max-width: 80%;
        font-size: 16px;
        font-weight: bold;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #171717;
    }
    .media-title .title-more{
        float: right;
        color: #327CE9;
        font-size: 12px;
        margin-top: 2px;
    }
    .media-content{
        width: 100%;
    }
    .my-swipe{
      padding: 10px 0;
    }
    .swiper-slide {
      width: 40%;
    }
    .micro-item{
      height: 245px;
      overflow: hidden;
      padding-right: 5px;
    }
    
    .swiper-img{
      width: 145px;
      background: red;
    }
</style>
